import React, { useEffect, useState } from "react";

export default function ErrorToster({ errorMessage }) {
  return (
    <div className="flex flex-row justify-center items-center gap-2  min-h-[44px] px-[21px] rounded-[10px] bg-pkt-FFE8E9">
      <img
        src={`${process.env.PUBLIC_URL || ""}/images/toaster/error.svg`}
        alt=""
        className="w-[14px] h-[14px]"
      />
      <span className="text-xs font-medium text-pkt-F1414B">
        {errorMessage}
      </span>
    </div>
  );
}
